import { render, staticRenderFns } from "./FixSmsContacts.vue?vue&type=template&id=7507639c&scoped=true"
import script from "./FixSmsContacts.vue?vue&type=script&lang=js"
export * from "./FixSmsContacts.vue?vue&type=script&lang=js"
import style0 from "./FixSmsContacts.vue?vue&type=style&index=0&id=7507639c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7507639c",
  null
  
)

export default component.exports